import SamplePreviewComponent from "./SamplePreviewComponent";
import ConnectionsEditComponent from "./ConnectionsEditComponent";
import WordEditComponent from "./WordEditComponent";
import SpellingBeeEditComponent from "./SpellingBeeEditComponent";
import CrosswordEditComponent from "./CrosswordEditComponent";
import WordSearchEditComponent from "./WordSearchEditComponent";
import SudokuEditComponent from "./SudokuEditComponent";
// Map of game IDs to calendar challenge components
// Extend this as needed for other games/components
const calendarGameMapping = {
  17: CrosswordEditComponent, // Use CrosswordEditComponent for game ID 17 (Crossword)
  21: SpellingBeeEditComponent, // Use SpellingBeeEditComponent for game ID 21 (Spelling Bee)
  39: SpellingBeeEditComponent, // Use SpellingBeeEditComponent for game ID 39 (Spelling Bee)
  23: ConnectionsEditComponent, // Use ConnectionsEditComponent for game ID 23 (Connections Puzzlefit)
  35: ConnectionsEditComponent, // Use ConnectionsEditComponent for game ID 35 (Connections Puzzlefit BE)
  37: ConnectionsEditComponent, // Use ConnectionsEditComponent for game ID 37 (Connections Sportniews)
  33: WordEditComponent, // Use WordEditComponent for game ID 33 (Horse Jump)
  24: WordEditComponent, // Use WordEditComponent for game ID 24 (Wordle DPG)
  29: WordEditComponent, // Use WordEditComponent for game ID 29 (Wordle CNN)
  30: WordEditComponent, // Use WordEditComponent for game ID 30 (Wordle Azerion)
  31: WordEditComponent, // Use WordEditComponent for game ID 31 (Wordle Azerion DE)
  42: WordEditComponent, // Use WordEditComponent for game ID 31 (N&M DE)
  22: WordSearchEditComponent, // Use WordSearchEditComponent for game ID 22 (Word Search)
  18: SudokuEditComponent, // Use SudokuEditComponent for game ID 18 (Sudoku CNN)
  19: SudokuEditComponent, // Use SudokuEditComponent for game ID 19 (Sudoku DPG)
  20: SudokuEditComponent, // Use SudokuEditComponent for game ID 20 (Sudoku Azerion)
  // Add more mappings as needed, e.g.:
  // 10: CustomCalendarComponent,
};

export default calendarGameMapping; 